import { ReactElement } from "react";

import styled from "styled-components";

export const getFormattedComment = (
  lastComment?: string,
  newComment?: string
): string => {
  if (
    (!lastComment || lastComment === "") &&
    (!newComment || newComment === "")
  ) {
    return "";
  }

  if (lastComment && lastComment !== "" && (!newComment || newComment === "")) {
    return lastComment;
  }

  const now = new Date();
  const year = `${now.getFullYear()}`;
  const month = `${now.getMonth() + 1}`;
  const date = `${now.getDate()}`;
  const ymd = `(${year}/${month.padStart(2, "0")}/${date.padStart(2, "0")})`;

  if (!lastComment || lastComment === "") {
    return `${ymd} ${newComment}`;
  }
  return `${lastComment}\r\n${ymd} ${newComment}`;
};

const NewLineText = styled.div`
  white-space: pre-wrap;
`;
export const showCommentInHTML = (comment: string): ReactElement => (
  <NewLineText>{comment}</NewLineText>
);
